import React from "react";
import ReactDOM from "react-dom/client"; // <-- Change import to "react-dom/client"
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ReactGA from "react-ga4";

// Initialize Google Analytics
ReactGA.initialize("G-15K7SCEGLM");

ReactGA.send({
  hitType: "pageview",
  page: "/my-path",
  title: "Custom Title",
});

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>
);
